import { IStorageClassSelector } from './model'

export const isDefaultStorageClass = (storageClass: Partial<IStorageClassSelector>) =>
  storageClass?.metadata?.annotations?.['storageclass.kubernetes.io/is-default-class'] === 'true'
